import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectMyInquiriesState = (state: RootState) => state.myInquiries;

export const selectMyInquiries = createSelector(
  selectMyInquiriesState,
  (myInquiriesState) => myInquiriesState.myInquiries
);
